import axios from "axios";

export class ChatService {
  async getChatEndpointUrl(): Promise<any> {
    return await axios.get(`api/chats/messaging_session_endpoint`);
  }
  async sendChatMessage(id: number, data): Promise<any> {
    return await axios.post(
      `api/super_space_users/${id}/send_chat_message`,
      data
    );
  }

  async sendRoomMessage(roomId: number, data): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/send_chat_message`, data);
  }

  async joinRoomChat(roomId: number, pinToJoin: number | null): Promise<any> {
    return await axios.post(`/api/rooms/${roomId}/join_chat`, {
      pinToJoin,
    });
  }

  async leaveRoomChat(roomId: number): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/leave_chat`, {});
  }

  async getMessagesInChat(id: number, nextToken: string = null): Promise<any> {
    return await axios.get(
      `api/super_space_users/${id}/chat${
        nextToken ? `?nextToken=${nextToken}` : ""
      }`
    );
  }

  async joinSpaceChat(spaceId: number): Promise<any> {
    return await axios.post(`api/spaces/${spaceId}/join_chat`, {});
  }
  async sendSpaceMessage(spaceId: number, data): Promise<any> {
    return await axios.post(`api/spaces/${spaceId}/send_chat_message`, data);
  }

  async getSpaceMessage(
    spaceId: number,
    nextToken: string = null
  ): Promise<any> {
    return await axios.get(
      `api/spaces/${spaceId}/chat${nextToken ? `?nextToken=${nextToken}` : ""}`
    );
  }
  async getRoomMessage(roomId: number, nextToken: string = null): Promise<any> {
    return await axios.get(
      `api/rooms/${roomId}/chat${nextToken ? `?nextToken=${nextToken}` : ""}`
    );
  }
  async pinMessage(data): Promise<any> {
    return await axios.post(`api/pin_chat_messages`, data);
  }

  async getPinnedMessage(id, spaceId, roomId): Promise<any> {
    let parameter = `space=${spaceId}`;
    if (roomId) parameter = `room=${roomId}`;
    return await axios.get(`api/pin_chat_messages?${parameter}`);
  }
  async deletePinnedMessage(id): Promise<any> {
    return await axios.delete(`api/pin_chat_messages/${id}`);
  }
  async getOpenChats(spaceId, page, search): Promise<any> {
    return await axios.get(
      `api/chat_one_to_ones?space=${spaceId}&page=${page}${search}`
    );
  }
  async clearChat(spaceId: string): Promise<any> {
    return await axios.delete(`api/spaces/${spaceId}/chat`);
  }
}
